import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "lib/theme";
import "./ThemeToggle.scss";

const SunIcon: FC = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
    <circle cx="12" cy="12" r="4.2" fill="currentColor" />
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <line x1="12" y1="2.5" x2="12" y2="5" />
      <line x1="12" y1="19" x2="12" y2="21.5" />
      <line x1="2.5" y1="12" x2="5" y2="12" />
      <line x1="19" y1="12" x2="21.5" y2="12" />
      <line x1="5.2" y1="5.2" x2="6.9" y2="6.9" />
      <line x1="17.1" y1="17.1" x2="18.8" y2="18.8" />
      <line x1="18.8" y1="5.2" x2="17.1" y2="6.9" />
      <line x1="6.9" y1="17.1" x2="5.2" y2="18.8" />
    </g>
  </svg>
);

const MoonIcon: FC = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
    <path
      fill="currentColor"
      d="M20 14.5A8 8 0 1 1 9.5 4a6.3 6.3 0 0 0 10.5 10.5z"
    />
  </svg>
);

const ThemeToggle: FC = () => {
  const { t } = useTranslation();
  const [theme, toggle] = useTheme();
  const isDark = theme === "dark";

  return (
    <div className="theme-toggle">
      <span className="theme-toggle__title">{t("theme")}</span>
      <button
        type="button"
        role="switch"
        aria-checked={isDark}
        aria-label={t("theme")}
        title={isDark ? t("light") : t("dark")}
        className={`theme-toggle__switch ${isDark ? "is-dark" : ""}`}
        onClick={toggle}
        data-testid="theme-toggle"
      >
        <span className="theme-toggle__icon theme-toggle__icon--sun">
          <SunIcon />
        </span>
        <span className="theme-toggle__icon theme-toggle__icon--moon">
          <MoonIcon />
        </span>
        <span className="theme-toggle__thumb" />
      </button>
    </div>
  );
};

export default ThemeToggle;
